import React from "react";
import LegalLayout, {
  Section,
  Bullets,
  SupportLine,
} from "@/pages/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      lastUpdated="December 2025"
      testid="privacy-page"
    >
      <Section heading="Overview">
        <p>
          This Privacy Policy explains how CV AI PRO (&quot;we&quot;, &quot;us&quot;) collects,
          stores, and uses your personal information when you use our resume
          optimization services. By using the service, you agree to the
          practices described below.
        </p>
      </Section>

      <Section heading="Information We Collect">
        <p>To deliver your optimized resume, we collect:</p>
        <Bullets
          items={[
            "Full name and email address",
            "Uploaded resumes and any documents you submit",
            "LinkedIn profile URL (when provided)",
            "Desired job role, work experience, and skills",
            "Additional notes or preferences you share with us",
            "Order and payment confirmation data from Stripe (we never see your card details)",
          ]}
        />
      </Section>

      <Section heading="How We Use Your Data">
        <p>Your information is used strictly to provide the service:</p>
        <Bullets
          items={[
            "Generate, optimize, and deliver your AI-crafted resume",
            "Communicate updates, deliveries, and support responses",
            "Process payments and prevent fraud",
            "Improve the quality of our resume optimization engine",
          ]}
        />
      </Section>

      <Section heading="Data Storage & Security">
        <p>
          Your data is stored securely in a managed MongoDB database. Uploaded
          files are kept only as long as needed to deliver your service and
          provide support. We apply industry-standard safeguards to protect
          your information from unauthorized access.
        </p>
      </Section>

      <Section heading="We Do Not Sell Your Data">
        <p>
          We do not sell, rent, or trade your personal data to third parties.
          The only third parties involved are essential service providers —
          Stripe for payment processing and our infrastructure provider for
          hosting — and only the minimum data required.
        </p>
      </Section>

      <Section heading="Your Rights">
        <p>
          You may request access to, correction of, or deletion of your
          personal data at any time. Send a request to{" "}
          <a
            href="mailto:getcvaipro@gmail.com?subject=Privacy%20Request"
            className="text-zinc-200 hover:text-white underline underline-offset-2"
          >
            getcvaipro@gmail.com
          </a>{" "}
          and we will respond within a reasonable timeframe.
        </p>
      </Section>

      <Section heading="Cookies & Analytics">
        <p>
          The site uses minimal cookies for performance and basic analytics. We
          do not use advertising trackers or third-party retargeting.
        </p>
      </Section>

      <Section heading="Contact">
        <SupportLine />
      </Section>
    </LegalLayout>
  );
}
